module.exports = __webpack_public_path__ + "media/images/profile/send-message-c0cc72421c868f83560b293f92d42027.svg";